// Shared lucide icon registry for references (showcase cards + case-study
// capabilities). Icons are stored by string key in the database so the admin can
// pick one without shipping component references. Unknown keys fall back to Boxes.

import {
  Megaphone,
  ShoppingBag,
  ShieldCheck,
  Contact,
  Sparkles,
  Users,
  Boxes,
  FolderLock,
  MessagesSquare,
  PackageCheck,
  FileSignature,
  BarChart3,
  LayoutDashboard,
  Cpu,
  Globe,
  Lock,
  Rocket,
  Workflow,
  Database,
  LineChart,
  Bot,
  Building2,
  CreditCard,
  Truck,
  Languages,
  Tags,
  type LucideIcon,
} from "lucide-react";

export const REFERENCE_ICONS: Record<string, LucideIcon> = {
  Megaphone,
  ShoppingBag,
  ShieldCheck,
  Contact,
  Sparkles,
  Users,
  Boxes,
  FolderLock,
  MessagesSquare,
  PackageCheck,
  FileSignature,
  BarChart3,
  LayoutDashboard,
  Cpu,
  Globe,
  Lock,
  Rocket,
  Workflow,
  Database,
  LineChart,
  Bot,
  Building2,
  CreditCard,
  Truck,
  Languages,
  Tags,
};

/** Ordered list of selectable icon keys for the admin picker. */
export const REFERENCE_ICON_KEYS = Object.keys(REFERENCE_ICONS);

/** Resolve an icon key to a component, defaulting to Boxes. */
export function referenceIcon(key: string | undefined): LucideIcon {
  return (key && REFERENCE_ICONS[key]) || Boxes;
}
